var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"media"},[_c(_setup.MediaPanel,{attrs:{"can-edit":_vm.org.canEdit,"org-id":_vm.org.id,"title":`${_vm.org.name} Clips`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }